// @flow
import {applyMiddleware, createStore} from 'redux'
import thunk from 'redux-thunk'

import promise from './promise'
import array from './array'
import analytics from './analytics'
import reducers from '../reducers'
import {createLogger} from 'redux-logger'
import {persistStore, autoRehydrate} from 'redux-persist'

const isDebuggingInChrome = process.env.NODE_ENV === 'development' && !!window.navigator.userAgent

const logger = createLogger({
  predicate: (getState, action) => isDebuggingInChrome,
  collapsed: true,
  duration: true,
})

const createAppStore = applyMiddleware(thunk, promise, array, analytics, logger)(createStore)

function configureStore(onComplete?: () => void) {
  // TODO(frantic): reconsider usage of redux-persist, maybe add cache breaker
  const store = autoRehydrate()(createAppStore)(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
  persistStore(store, {keyPrefix: 'reduxPersistApp:'}, onComplete)
  if (isDebuggingInChrome) {
    window.store = store
  }
  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.js